import coinAmount from "./coin-amount.mjs";
import { ArgumentError } from "../../../utils/errors.mjs";
/**
 * Oracle query fee
 */
export default {
  ...coinAmount,
  async prepare(value, params, options) {
    if (value != null) return value;
    const {
      onNode,
      oracleId
    } = options;
    const requirement = 'provided (or provide `queryFee` instead)';
    if (onNode == null) throw new ArgumentError('onNode', requirement, onNode);
    if (oracleId == null) throw new ArgumentError('oracleId', requirement, oracleId);
    return (await onNode.getOracleByPubkey(oracleId)).queryFee.toString();
  }
};
//# sourceMappingURL=query-fee.mjs.map